import React from 'react';
import { Placeholder } from 'react-bootstrap';

export function NotificationItemSkeleton() {
    return (
        <div className="position-relative mb-1 item placeholder-glow" aria-hidden="true">
            <div className="d-flex align-items-start">
                <Placeholder className="skeleton skeleton-notification-icon" />
                <div className="d-flex align-items-center justify-content-between w-100 ml-2">
                    <div className="flex-grow-1">
                        <Placeholder xs={5} className="skeleton skeleton-table-name d-block mb-2" />
                        <Placeholder xs={11} className="skeleton skeleton-description-line d-block mb-1" />
                        {/* <Placeholder xs={7} className="skeleton skeleton-description-line d-block" /> */}
                    </div>
                    <Placeholder
                        className="skeleton mx-2"
                        style={{ width: 4, height: 18, borderRadius: 2, flexShrink: 0 }}
                    />
                </div>
            </div>
        </div>
    );
}
